import {
  Box,
  Flex,
  Button,
  VStack,
  HStack,
  IconButton,
  Link as ChakraLink,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Image,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Collapse,
} from "@chakra-ui/react";
import { FaBars } from "react-icons/fa";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import { darkColor, mainColor } from "./mainPage/MainPage";
import logo_white from "../assets/logo/logo_white.png";
import logo from "../assets/logo/logo_wobble.png";
import { useState } from "react";

const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [isKiknekOpen, setIsKiknekOpen] = useState(false);

  const linkStyles = {
    color: mainColor,
    fontWeight: "bold",
    fontSize: "md",
    py: 1,
    _hover: { textDecoration: "none" },
    width: "100%",
    textAlign: "left" as const,
  };

  return (
    <>
      <Flex
        as="header"
        bg={mainColor}
        color="white"
        py={4}
        px={8}
        justify="space-between"
        align="center"
        position="sticky"
        top="0"
        zIndex="1000"
        // w="100%"
      >
        <Box h={34} w={140} objectFit="cover">
          <Link to="/">
            <Image src={logo_white} alt="logo" />
          </Link>
        </Box>
        <HStack
          spacing={{ base: 1, md: 2 }}
          display={{ base: "none", lg: "flex" }}
        >
          <ChakraLink
            href="/"
            p={1}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
          >
            Főoldal
          </ChakraLink>
          <ChakraLink
            href="/funkciok"
            p={1}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
          >
            Funkciók
          </ChakraLink>
          <ChakraLink
            href="/online-idopontfoglalo"
            p={1}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
          >
            Időpontfoglaló
          </ChakraLink>
          {/* <ChakraLink
            href="/landing-oldal"
            p={1}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
          >
            Landing oldal
          </ChakraLink> */}
          <ChakraLink
            href="/weboldal"
            p={1}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
          >
            Weboldal
          </ChakraLink>
          <ChakraLink
            href="/beagyazas"
            p={1}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
          >
            Beágyazás
          </ChakraLink>
          <Menu>
            <MenuButton
              as={ChakraLink}
              p={1}
              _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
            >
              <Flex align="center" gap={1}>
                Kiknek?
                <ChevronDownIcon />
              </Flex>
            </MenuButton>
            <MenuList bg={mainColor} color="white" borderColor={darkColor}>
              <MenuItem
                as="a"
                href="/kozmetikusok"
                _hover={{
                  bg: darkColor,
                  textDecoration: "none",
                  rel: "noopener noreferrer",
                }}
                bg={mainColor}
              >
                Szépségiparban dolgozóknak
              </MenuItem>
              <MenuItem
                as="a"
                href="/lovardak"
                _hover={{
                  bg: darkColor,
                  textDecoration: "none",
                  rel: "noopener noreferrer",
                }}
                bg={mainColor}
              >
                Lovardáknak
              </MenuItem>
              <MenuItem
                as="a"
                href="/edzok"
                _hover={{
                  bg: darkColor,
                  textDecoration: "none",
                  rel: "noopener noreferrer",
                }}
                bg={mainColor}
              >
                Edzőknek, oktatóknak
              </MenuItem>
              <MenuItem
                as="a"
                href="/workshopok"
                _hover={{
                  bg: darkColor,
                  textDecoration: "none",
                  rel: "noopener noreferrer",
                }}
                bg={mainColor}
              >
                Workshop szervezőknek
              </MenuItem>
              <MenuItem
                as="a"
                href="/masszorok"
                _hover={{
                  bg: darkColor,
                  textDecoration: "none",
                  rel: "noopener noreferrer",
                }}
                bg={mainColor}
              >
                Masszőröknek
              </MenuItem>
              {/* <MenuItem
                as="a"
                href="/fodraszok"
                _hover={{
                  bg: darkColor,
                  textDecoration: "none",
                  rel: "noopener noreferrer",
                }}
                bg={mainColor}
              >
                Fodrászok
              </MenuItem> */}
              <MenuItem
                as="a"
                href="/kutyakozmetika"
                _hover={{
                  bg: darkColor,
                  textDecoration: "none",
                  rel: "noopener noreferrer",
                }}
                bg={mainColor}
              >
                Kutyakozmetikusoknak
              </MenuItem>
            </MenuList>
          </Menu>
          <ChakraLink
            href="/csomagok"
            p={1}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
          >
            Árak
          </ChakraLink>
          <ChakraLink
            href="/videok"
            p={1}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
          >
            Videók
          </ChakraLink>
          <ChakraLink
            href="/partner"
            p={1}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
          >
            Partnerség
          </ChakraLink>
          <ChakraLink
            as={Link}
            to="/blog"
            p={1}
            mr={2}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Blog
          </ChakraLink>
          <ChakraLink
            as={Link}
            to="https://help.wobble.hu/"
            p={1}
            mr={2}
            _hover={{ textDecoration: "none", bg: darkColor, rounded: 5 }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Súgó
          </ChakraLink>
        </HStack>
        <HStack spacing={4} display={{ base: "none", lg: "flex" }}>
          <Button
            colorScheme="white"
            variant="link"
            as="a"
            href="https://app.wobble.hu/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            Belépés
          </Button>
          <Button
            colorScheme="white"
            variant="outline"
            as="a"
            href="https://app.wobble.hu/signup_page"
            target="_blank"
            rel="noopener noreferrer"
            _hover={{
              backgroundColor: darkColor,
              textDecoration: "none",
            }}
          >
            Regisztráció
          </Button>
        </HStack>
        <IconButton
          aria-label="Open Menu"
          icon={<FaBars />}
          display={{ base: "flex", lg: "none" }}
          onClick={onOpen}
          colorScheme="white"
        />
      </Flex>

      {/* Mobile Drawer */}
      <Drawer placement="top" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton color="teal" />
            <DrawerHeader>
              <Box h={34} w={140} objectFit="cover">
                <Image src={logo} alt="logo" />
              </Box>
            </DrawerHeader>
            <DrawerBody>
              <VStack spacing={2} align="start">
                <ChakraLink href="/" onClick={onClose} {...linkStyles}>
                  Főoldal
                </ChakraLink>
                <ChakraLink href="/funkciok" onClick={onClose} {...linkStyles}>
                  Funkciók
                </ChakraLink>

                <Button
                  onClick={() => setIsKiknekOpen(!isKiknekOpen)}
                  variant="ghost"
                  rightIcon={
                    <ChevronDownIcon
                      transform={
                        isKiknekOpen ? "rotate(180deg)" : "rotate(0deg)"
                      }
                      transition="transform 0.2s"
                    />
                  }
                  color={mainColor}
                  fontWeight="bold"
                  width="100%"
                  justifyContent="space-between"
                  px={0}
                  _hover={{ bg: "transparent" }}
                >
                  Kiknek?
                </Button>

                <Collapse
                  in={isKiknekOpen}
                  animateOpacity
                  style={{ width: "100%" }}
                >
                  <VStack align="start" pl={4} spacing={1} mt={1}>
                    <ChakraLink
                      href="/kozmetikusok"
                      onClick={onClose}
                      {...linkStyles}
                    >
                      Szépségiparban dolgozók
                    </ChakraLink>
                    <ChakraLink
                      href="/lovardak"
                      onClick={onClose}
                      {...linkStyles}
                    >
                      Lovardáknak
                    </ChakraLink>
                    <ChakraLink
                      href="/workshopok"
                      onClick={onClose}
                      {...linkStyles}
                    >
                      Workshop szervezőknek
                    </ChakraLink>
                    <ChakraLink
                      href="/edzok"
                      onClick={onClose}
                      {...linkStyles}
                    >
                      Edzőknek, oktatóknak
                    </ChakraLink>
                    <ChakraLink
                      href="/masszorok"
                      onClick={onClose}
                      {...linkStyles}
                    >
                      Masszőröknek
                    </ChakraLink>
                    {/* <ChakraLink
                      href="/fodraszok"
                      onClick={onClose}
                      {...linkStyles}
                    >
                      Fodrászok
                    </ChakraLink> */}
                    <ChakraLink
                      href="/kutyakozmetika"
                      onClick={onClose}
                      {...linkStyles}
                    >
                      Kutyakozmetikusoknak
                    </ChakraLink>
                  </VStack>
                </Collapse>

                <ChakraLink href="/landing-oldal" onClick={onClose} {...linkStyles}>
                  Landing oldal
                </ChakraLink>
                <ChakraLink href="/weboldal" onClick={onClose} {...linkStyles}>
                  Weboldal
                </ChakraLink>
                <ChakraLink href="/beagyazas" onClick={onClose} {...linkStyles}>
                  Beágyazás
                </ChakraLink>
                <ChakraLink href="/csomagok" onClick={onClose} {...linkStyles}>
                  Árak
                </ChakraLink>
                <ChakraLink href="/videok" onClick={onClose} {...linkStyles}>
                  Videók
                </ChakraLink>
                <ChakraLink href="/partner" onClick={onClose} {...linkStyles}>
                  Partnerség
                </ChakraLink>
                <ChakraLink
                  as={Link}
                  to="/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={onClose}
                  {...linkStyles}
                >
                  Blog
                </ChakraLink>
                <ChakraLink
                  as={Link}
                  to="https://help.wobble.hu/"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={onClose}
                  {...linkStyles}
                >
                  Súgó
                </ChakraLink>
              </VStack>
            </DrawerBody>
            <DrawerFooter justifyContent="center">
              <Button
                as="a"
                href="https://app.wobble.hu/login"
                target="_blank"
                rel="noopener noreferrer"
                colorScheme="teal"
                width="200px"
                // variant="outline"
                onClick={onClose}
                m={8}
              >
                Belépés
              </Button>
              <Button
                as="a"
                href="https://app.wobble.hu/signup_page"
                target="_blank"
                rel="noopener noreferrer"
                width="200px"
                colorScheme="teal"
                // variant="outline"
                onClick={onClose}
                m={8}
              >
                Regisztráció
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </>
  );
};

export default Navbar;
